export class OptionDto {
  limit = 10;
  endAt =  Number(new Date()) + 10 * 60 * 1000;
  history = false;
}
